import { useMutation, useQueryClient } from "@tanstack/react-query";

import { IAddBillableDeviceRequest } from "../../../@types/admin/AdminBillableDevice";
import { billableDevicesService } from "../../../services/admin";
import { ensureOk } from "../../../utils/ensureOk";

export function useAddBillableDevice() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (request: IAddBillableDeviceRequest) =>
      ensureOk(await billableDevicesService.addBillableDevice(request)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin-billable-devices"] });
    },
  });

  return { addBillableDevice: mutateAsync, isAddingBillableDevice: isPending };
}

export function useArchiveBillableDevice() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (id: string) =>
      ensureOk(await billableDevicesService.archiveBillableDevice(id)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin-billable-devices"] });
    },
  });

  return {
    archiveBillableDevice: mutateAsync,
    isArchivingBillableDevice: isPending,
  };
}
